import React, {Component, useContext} from 'react';
import ReactDOM from 'react-dom';
import { Layout, SixtyFourtyLayout } from '../../../../layouts';
import Welcome from '../../../../layouts/welcome';
import Row from '../../../../components/row';
import { ButtonCancel, ButtonModify, ButtonProceed, ButtonRemove, ButtonReturn, ButtonSave, ButtonView } from '../../../../components/buttons';
import Container from '../../../../layouts/containers/container';

import TabBar from '../../components/tab-bar';
import companiesApi from '../../../../lib/companies/companies-api';
import List from '../../../../components/list';
import ContainerIndex from '../../../../layouts/containers/container-index';
import Divider from '../../../../components/divider/divider';
import Grid from '../../../../components/grid';
import InputsText from '../../../../components/inputs/inputs-text';
import InputsDropdown from '../../../../components/inputs/inputs-dropdown';
import PopupContext from '../../../../context/context-popup';
import PopupsDeleteMember from '../../popups/popups-delete-member';
import PopupsInviteUser from '../../popups/popups-invite-user';
import ContentDropdown from '../../../../components/content-dropdown';
import PopupsRemoveInvite from '../../popups/popups-remove-invite';
import LabelContainer from '../../../../components/label-container';
import { stringToFriendlyDatetime } from '../../../../lib/helpers/datetime-helpers';
import adminApi from '../../../../lib/admin/admin-api';
import usersApi from '../../../../lib/users/users-api';
import { SmallPill } from '../../../../components/pills';
import MediaHelper from '../../../../lib/helpers/media';
import PlainCard from '../../../../components/cards/card-plain';
import classNames from 'classnames';
import InputsSwitch from '../../../../components/inputs/inputs-switch';

const el = document.getElementById('account-user');

import ActivityItemNew from '../../../../components/activity/activity-item-new';
import activityParams from '../../../../lib/users/activity';
import RenderThisIf from '../../../../components/renderIf';
import EmptyState from '../../../../components/states/empty';
import Scrollable from '../../../../components/scrollable';

class UserActivity extends Component {
    constructor(props) {
        super(props);

        this.state = {
            activity: []
        }
    }

    componentDidMount() {
        companiesApi.userActions(window?.user?.company_id, this.props.id).then(({ data }) => {
            this.setState({ activity: data });
        })
    }

    render() {
        return (
            <Container>
                <Container.Header>
                    <Container.Text fontSize="30px" color="#FF6933">Activity</Container.Text>
                </Container.Header>

                <Container.Content style={{
                    height: this.state.activity?.length === 0 ? '400px' : ''
                }}>
                    <RenderThisIf 
                        renderIf={this.state.activity?.length === 0}
                        render={<EmptyState showImage={false} title="Activity" description="There has been no recent activity"/>}
                    >
                        <Scrollable maxItems={6} itemHeight={111.73} spacing={20}>
                            <List gap="20px">
                                { this.state.activity?.map((activity) => {
                                    const params = activityParams(activity);

                                    return <ActivityItemNew 
                                        icon={false}
                                        className="dashboard-activity-item"
                                        subtitle={params?.message}
                                        title={params?.body}
                                        body={params?.created_at}
                                    />
                                }) }
                            </List>
                        </Scrollable>
                    </RenderThisIf>
                </Container.Content>
            </Container>
        )
    }
}

class User extends Component {
    constructor() {
        super();

        this.state = {
            user: null,
            roles: [],
            role_ids: []
        }
    }

    componentDidMount() {
        this.fetch();
        this.fetchRoles();
    }

    fetch() {
        companiesApi.user(window.user?.company_id, this.props.id).then(({ data }) => {
            this.setState({ user: data, role_ids: data?.roles?.map(({ id }) => id) }, () => {
                this.props.setRoles(data?.roles?.map(({ id }) => id));
            })
        })
    }

    fetchRoles() {
        adminApi.getRoles().then(({ data }) => {
            this.setState({ roles: data });
        })
    }

    onRoleAdd(id, callback) {
        const role_ids = [ ...this.state.role_ids ];

        if (!role_ids.includes(id)) role_ids.push(id);

        this.setState({ role_ids }, () => {
            this.props.setRoles(role_ids, callback);
        })
    }

    onRoleDelete(id, callback) {
        let role_ids = [ ...this.state.role_ids ];

        role_ids = role_ids.filter((role) => role !== id);

        this.setState({ role_ids }, () => {
            this.props.setRoles(role_ids, callback);
        })
    }

    modifyRole(role, hasRole) {
        if (hasRole) return this.onRoleDelete(role.id, () => this.props.save(this.fetch.bind(this)));

        return this.onRoleAdd(role.id, () => this.props.save(this.fetch.bind(this)));
    }

    renderRolesAdmin() {
        return this.state?.roles?.map((role, index) => {
            const hasRole = this.state.user?.roles?.find(r => r.id === role.id);

            const className = classNames({
                "plain-card--green": hasRole,
                "plain-card--red": !hasRole
            })
            
            return <PlainCard key={index} type={className}>
                <Row gap="20px" justifyContent="space-between" alignItems="flex-end">
                    <List gap="5px">
                        <Container.Text fontSize="20px" color="white">{ role?.name }</Container.Text>
                        <Container.Text fontSize="16px" color="rgb(236 236 236)">{ role?.description }</Container.Text>
                    </List>

                    <InputsSwitch mobile checked={hasRole} onChange={() => this.modifyRole(role, hasRole)}/>
                </Row>  
            </PlainCard>
        }) 
    }

    renderRolesUser() {
        return this.state?.role_ids?.map((id, index) => {
            const role = this.state.roles?.find(r => r.id === id);

            return <PlainCard key={index} type={'plain-card--green'}>
                <List gap="5px">
                    <Container.Text fontSize="20px" color="white">{ role?.name }</Container.Text>
                    <Container.Text fontSize="16px" color="rgb(236 236 236)">{ role?.description }</Container.Text>
                </List>
            </PlainCard>
        });
    }

    renderRoles() {
        const userIsAdmin = window.user?.roles?.find(role => role.name === 'Owner' || role.name === 'Manager');

        if (userIsAdmin) return this.renderRolesAdmin();

        return this.renderRolesUser();
    }

    render() {
        const name = this.state?.user?.name?.split(' ');

        const first = name?.[0];
        const last = name?.[1];

        const first_name = this.state.user?.user_profile?.first_name;
        const last_name = this.state.user?.user_profile?.last_name;

        return (
            <List gap="40px" divider={<Divider/>}>
                <Container>
                    <Container.Header>
                        <Container.Text fontSize="30px" color="#FF6933">About Me</Container.Text>
                    </Container.Header>

                    <Container.Content>
                        <List gap="20px">
                            <LabelContainer label="Profile Picture">
                                <div style={{
                                    width: '158px',
                                    height: '158px',
                                    backgroundColor: '#FCF7FF',
                                    border: '1px solid #C6C7D1',
                                    borderRadius: '50%',
                                    backgroundImage: `url('${MediaHelper.formatPublicPath(`/images/${this.state.user?.user_profile?.profile_img}`)}')`
                                }}></div>
                            </LabelContainer>

                            <Grid gap="40px" columns={2}>
                                <LabelContainer label="First Name">
                                    { first_name || first }
                                </LabelContainer>

                                <LabelContainer label="Last Name">
                                    { last_name || last }
                                </LabelContainer>

                                <LabelContainer label="Email Address">
                                    { this.state?.user?.email }
                                </LabelContainer>
                            </Grid>
                        </List>
                    </Container.Content>
                </Container>

                <Container>
                    <Container.Header>
                        <Container.Text fontSize="30px" color="#FF6933">Roles</Container.Text>
                    </Container.Header>

                    <Container.Content>
                        <ContainerIndex>
                            <ContainerIndex.Content>
                                { this.renderRoles() }
                            </ContainerIndex.Content>
                        </ContainerIndex>
                    </Container.Content>
                </Container>
            </List>
        )
    }
}

class App extends Component {
    constructor(props) {
        super(props);
    }

    setRoles(role_ids, callback = () => {}) {
        this.setState({ role_ids }, callback)
    }

    save(callback = () => {}) {
        companiesApi.updateUserRoles(window.user?.company_id, this.props.id, {
            role_ids: this.state.role_ids
        }, () => {
            toast.error("There has been an error", {
                position: toast.POSITION.BOTTOM_CENTER
            });
        }).then(callback)
    }

    render() {
        return (
            <Layout 
                theme="light"
                topLeft={
                    <Welcome 
                        title={<Container.Text fontSize="18px" color="#FF6933">Manage</Container.Text>}
                        subtitle="User"
                    />
                }
                topRight={
                    <Row gap="20px">
                        <ButtonSave onClick={this.save.bind(this)}>Save</ButtonSave>
                        <ButtonReturn>Cancel</ButtonReturn>
                    </Row>
                }
            >
                <List gap="40px">
                    <TabBar active={2}/>

                    <SixtyFourtyLayout
                        main={<User id={this.props.id} save={this.save.bind(this)} setRoles={this.setRoles.bind(this)}/>}
                        sectionOne={{
                            name: '',
                            component: <UserActivity id={this.props.id}/>
                        }}
                    />
                </List>
            </Layout>    
        )
    }
}

if (el) {
    ReactDOM.render(
       <App id={el.getAttribute('data-id')}/>
    , el);
}
